function mobileToggleTab(e) {
  e.preventDefault();

	const tabs = document.querySelectorAll('.block-tab-side-image-tab.active');

  tabs.forEach((tab) => {
    tab.classList.remove('active');
    tab.children[0].classList.remove('active');
  });

	e.currentTarget.parentElement.parentElement.classList.add('active');
	e.currentTarget.parentElement.classList.add('active');
};

function setSpacerSize() {
	const tabContents = document.querySelectorAll(
		'.block-tab-side-image-tab > .block-tab-side-image-tab-content'
	);
	const spacer = document.querySelector(
		'.block-tab-side-image .block-tab-side-image__spacer-inner'
	);

	let tallest = 0;
	let tabHeight;

	for (let i = 0; i < tabContents.length; i++) {
		tabHeight = tabContents[i].getBoundingClientRect().height;
		if (tabHeight > tallest) {
			tallest = tabHeight;
		}
	}

	if (tallest !== 0) {
		spacer.style.setProperty('--tallest-tab', `${tallest}px`);
	}
}

function getTranslateYValue(element) {
	const transform = window.getComputedStyle(element).getPropertyValue('transform');

	const translateY = transform.split(',')[5].trim().slice(0, -1);
	return parseFloat(translateY);
}

function animationInit() {
	const tabContents = document.querySelectorAll('.block-tab-side-image-tab-content');

	if (matchMedia('(min-width: 768px)').matches) {
		let previousTabContentsSize = 0;
	
		tabContents.forEach((tabContent, id) => {
			if (0 === id) {
				tabContent.previousElementSibling.classList.add('active');
				tabContent.parentElement.classList.add('active');
			} else {
				tabContent.previousElementSibling.classList.remove('active');
				tabContent.parentElement.classList.remove('active');
			}
			tabContent.style.transform = `translateY(${previousTabContentsSize}px)`;
			previousTabContentsSize += tabContent.getBoundingClientRect().height;
		});
	} else {
		tabContents.forEach((tabContent) => {
			tabContent.style.transform = "none";
		});
	}
}

function animationUpdate(e) {
	const tabs = Array.from(document.querySelectorAll('.block-tab-side-image-tab'));
	const tabButtons = tabs.map((tab) => tab.children[0]);
	const tabContents = tabs.map((tab) => tab.children[1]);

	const tabButtonID = tabButtons.indexOf(e.currentTarget.parentElement);
	const tabContent = tabContents[tabButtonID];
	const clickedTranslateY = getTranslateYValue(tabContent);

	tabContents.forEach((content) => {
		const tabContentTranslateY = getTranslateYValue(content);

		content.style.transform = `translateY(${tabContentTranslateY - clickedTranslateY}px)`;
	});
}

function initTabs() {
	const tabButtons = document.querySelectorAll(
		'.block-tab-side-image-tab > .wp-block-button .wp-block-button__link'
	);

	if (tabButtons.length > 0) {
		tabButtons.forEach((tabButton, id) => {
			if (0 === id) {
				tabButton.parentElement.classList.add('active');
				tabButton.parentElement.parentElement.classList.add('active');
			}

			tabButton.addEventListener('click', (e) => {
				mobileToggleTab(e);

				if (matchMedia('(min-width: 768px)').matches) {
					animationUpdate(e);
				}
			});
		});
	}

	setSpacerSize();
	animationInit();
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		initTabs();
	},
	loaded() {},
	resized() {
		setSpacerSize();
		animationInit();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
